module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "houseClientReport"
  }, [_vm._v("\n    ====================》这是houseClientReport页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d61473","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/houseClientReport.vue
// module id = 1156
// module chunks = 1